<template>
  <div class="container">
    <router-view class="espacio-contenido"/>
  </div>
</template>
<script>
</script>
<style>
.espacio-contenido {
  padding-bottom: 20px;
  padding-top: 20px;
}
</style>
<style src="./assets/css/global.css"></style>